import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

const BASE_PATH = environment.basePath;

@Injectable({
  providedIn: 'root',
})
export class MasterConsultaUsuariosService {
  constructor(private httpClient: HttpClient) {}

  getUsers() {
    return this.httpClient
      .get<any>(`${BASE_PATH}/bff/master/get-view-profiles/users/list`)
      .toPromise();
  }
}
